import { DateTimeFormatter } from "@js-joda/core";
import { Locale } from "@js-joda/locale_en-us";

export const monthYear = DateTimeFormatter.ofPattern("MMMM yyyy").withLocale(
	Locale.US,
);
